<template>
  <div
    v-if="isLoading"
    class="fixed flex h-full justify-center left-0 max-h-[100%] top-0 w-screen z-50"
    data-test="loader"
    tabindex="-1">
    <div class="bg-black fixed flex h-screen justify-center left-0 opacity-50 top-0 w-screen" />
    <div
      aria-modal="true"
      class="-translate-x-1/2 -translate-y-1/2 fixed grow left-1/2 top-1/2 transform w-[240px]"
      role="dialog">
      <div class="bg-white flex justify-center modal-content px-4 py-8 rounded-lg shadow-sm">
        <Spinner />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {Spinner} from '@myparcel-frontend/ui';
import useLoader from './useLoader';

const {isLoading} = useLoader();
</script>
